// import {testURL} from '../url/index'
import request from '@/util/request'

export function createQrCode (id) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/qr/create',
    method: 'post',
    data: id
  })
}



// WEBPACK FOOTER //
// ./src/api/qrcode.js